export const TwitterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 41" fill="none" {...props}>
    <path
      fill={props.color || '#707B8F'}
      d="M30.543 3.373h5.623l-12.284 14.04 14.45 19.103H27.019L18.156 24.93 8.016 36.516H2.39L15.528 21.5 1.666 3.373h11.602l8.01 10.59 9.265-10.59ZM28.57 33.151h3.115l-20.11-26.59H8.232l20.338 26.59Z"
    />
  </svg>
);
